import { isProdEnv } from '@vfde-sails/utils';
import { debugInfo } from './debug';
import { Domains, Endpoints, Queries } from '../enum';
import { getCMSConfig } from './cms';

type QueryParams = Record<string, string | number | boolean | string[] | number[] | undefined | null>;

export const getQueryString = (data: QueryParams = {}, queryString?: string) => {
    const params = new URLSearchParams(queryString);

    for (const [key, value] of Object.entries(data)) {
        value ? params.set(key, value.toString()) : params.delete(key);
    }

    return params.toString() ? `?${params}` : '';
};

/**
 * Get full URL from domain, endpoint and optional query parameters.
 * Allows the use of proxies in DEV environment by omitting the domain.
 * @param {string} domain - domain string
 * @param {string} endpoint - relative path on the domain
 * @param {QueryParams} query - optional object to create query from
 * @returns {string} - string from URL object, empty string if URL is invalid
 */
export const getUrl = (domain?: string, endpoint?: string, query?: QueryParams): string => {
    try {
        const base = isProdEnv() ? domain : location.href;
        const url = new URL(base || '');

        url.pathname = endpoint || '';
        url.search = getQueryString(query);

        return url.toString();
    } catch (error) {
        debugInfo(error);

        return '';
    }
};

/**
 * Create option page URL with the basket set from CMS
 * @returns {string} - option page URL
 */
export const getOptionsPageUrl = () => {
    const query = {
        [Queries.BASKET]: getCMSConfig().gigaTvMetaCode,
    };

    return getUrl(Domains.ZH, Endpoints.OPTION_PAGE, query);
};
